import React, { useEffect, useState } from "react";
import { getSprintReview } from "./api";
import { SprintBox } from "./ProgramDetail";
import { fmtDate, StatusFlag } from "./ProgramsTab";
import "./programs.css";

const FLAG_ORDER = { red: 0, yellow: 1, green: 2 };

function SprintSlot({ label, sprint, onChanged, editable }) {
  return (
    <div>
      <div className="pg-review-col-label">{label}</div>
      {sprint ? (
        <SprintBox sprint={sprint} onChanged={onChanged} editable={editable} />
      ) : (
        <div className="pg-empty-slot">—</div>
      )}
    </div>
  );
}

export default function SprintReviewTab() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  const load = () =>
    getSprintReview()
      .then((data) =>
        setRows(
          [...data].sort(
            (a, b) => (FLAG_ORDER[a.status_flag] ?? 3) - (FLAG_ORDER[b.status_flag] ?? 3)
          )
        )
      )
      .catch((e) => setError(e.message));

  useEffect(() => {
    load();
  }, []);

  if (error) return <div className="pg-error">{error}</div>;
  if (!rows) return <div className="pg-muted pg-wrap">Loading…</div>;
  if (rows.length === 0)
    return (
      <div className="pg-wrap">
        <div className="pg-empty-slot" style={{ padding: 40 }}>
          Sprints load automatically from program plans. Create a program on the Programs tab to
          see them here.
        </div>
      </div>
    );

  return (
    <div className="pg-wrap">
      {rows.map((r) => (
        <div className="pg-card" key={r.program_id}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <strong style={{ fontSize: 15 }}>
                {r.program_code} — {r.program_title}
              </strong>
              <StatusFlag flag={r.status_flag} comment={r.status_comment} />
            </div>
            <span className="pg-small pg-muted">{r.percent_complete}% complete</span>
          </div>
          {r.status_comment && (
            <div className="pg-small pg-muted" style={{ margin: "4px 0 0" }}>
              {r.status_comment}
            </div>
          )}
          <div className="pg-review-cols" style={{ marginTop: 12 }}>
            <SprintSlot label="Last sprint" sprint={r.previous_sprint} onChanged={load} editable={false} />
            <SprintSlot label="Current sprint" sprint={r.current_sprint} onChanged={load} editable />
            <SprintSlot label="Next sprint" sprint={r.next_sprint} onChanged={load} editable />
          </div>
          {r.gates_due.map((g) => (
            <div className="pg-gate-banner" key={g.gate_id}>
              <span style={{ fontWeight: 500 }}>{g.name}</span> decision due {fmtDate(g.decision_date)}
              {g.pending_approvers.length > 0 && (
                <span className="pg-small">
                  · awaiting: {g.pending_approvers.join(", ")}
                </span>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
